import {
  InnerBlocks,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';

import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

import classNames from 'classnames';

export default function save({ attributes }) {
  const { flexClass, media, mediaClass } = attributes;

  const biteBlockClass = ['bf_layout', flexClass];

  const blockProps = useBlockProps.save({
    className: '',
  });

  const biteBlockClasses = biteBlockClass.join(' ');
  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `${biteBlockClasses}`,
  });

  return (
    <section {...blockProps}>
      <div {...innerBlocksProps}>{children}</div>
      {media.id ? (
        <>
          {media.type === 'video' ? (
            <ResponsiveVideo media={media} mediaClass={`${mediaClass}`} />
          ) : (
            <ResponsiveImage media={media} mediaClass={`${mediaClass}`} />
          )}
        </>
      ) : null}
    </section>
  );
}
